module.exports = {
	services: {
		'service-account-recovery': {
			primary: 'https://api.prod.cuv-prod.com/1/service-account-recovery',
		},
		'service-admin': {
			primary: 'https://api.prod.cuv-prod.com/1/service-admin',
		},
		'service-auth': {
			primary: 'https://api.prod.cuv-prod.com/1/service-auth',
		},
		'service-auth-client': {
			primary: 'https://api.prod.cuv-prod.com/1/service-auth-client',
		},
		'service-auth-multi-factor': {
			primary: 'https://api.prod.cuv-prod.com/1/service-auth-multi-factor',
		},
		'service-auth-scopes': {
			primary: 'https://api.prod.cuv-prod.com/1/service-auth-scopes',
		},
		'service-ban-matching': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ban-matching',
		},
		'service-ban-review': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ban-review',
		},
		'service-career': {
			primary: 'https://api.prod.cuv-prod.com/1/service-career',
		},
		'service-change-request': {
			primary: 'https://api.prod.cuv-prod.com/1/service-change-request',
		},
		'service-code-mapping': {
			primary: 'https://api.prod.cuv-prod.com/1/service-code-mapping',
		},
		'service-contacts': {
			primary: 'https://api.prod.cuv-prod.com/1/service-contacts',
		},
		'service-content': {
			primary: 'https://api.prod.cuv-prod.com/1/service-content',
		},
		'service-credit-scoring': {
			primary: 'https://api.prod.cuv-prod.com/1/service-credit-scoring',
		},
		'service-cue': {
			primary: 'https://api.prod.cuv-prod.com/1/service-cue',
		},
		'service-data': {
			primary: 'https://api.prod.cuv-prod.com/1/service-data',
		},
		'service-data-cursor': {
			primary: 'https://api.prod.cuv-prod.com/1/service-data-cursor',
		},
		'service-document': {
			primary: 'https://api.prod.cuv-prod.com/1/service-document',
		},
		'service-doggos': {
			primary: 'https://api.prod.cuv-prod.com/1/service-doggos',
		},
		'service-driver-scoring': {
			primary: 'https://api.prod.cuv-prod.com/1/service-driver-scoring',
		},
		'service-driver-scoring-sentiance': {
			primary: 'https://api.prod.cuv-prod.com/1/service-driver-scoring-sentiance',
		},
		'service-driving-license-registration': {
			primary: 'https://api.prod.cuv-prod.com/1/service-driving-license-registration',
		},
		'service-driving-stats': {
			primary: 'https://api.prod.cuv-prod.com/1/service-driving-stats',
		},
		'service-dvla-ves': {
			primary: 'https://api.prod.cuv-prod.com/1/service-dvla-ves',
		},
		'service-email': {
			primary: 'https://api.prod.cuv-prod.com/1/service-email',
		},
		'service-env-config': {
			primary: 'https://api.prod.cuv-prod.com/1/service-env-config',
		},
		'service-experian-icache': {
			primary: 'https://api.prod.cuv-prod.com/1/service-experian-icache',
		},
		'service-experian-wasp': {
			primary: 'https://api.prod.cuv-prod.com/1/service-experian-wasp',
		},
		'service-finance': {
			primary: 'https://api.prod.cuv-prod.com/1/service-finance',
		},
		'service-id-lookup': {
			primary: 'https://api.prod.cuv-prod.com/1/service-id-lookup',
		},
		'service-ifttt': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ifttt',
		},
		'service-incident': {
			primary: 'https://api.prod.cuv-prod.com/1/service-incident',
		},
		'service-intercom': {
			primary: 'https://api.prod.cuv-prod.com/1/service-intercom',
		},
		'service-intercom-ops': {
			primary: 'https://api.prod.cuv-prod.com/1/service-intercom-ops',
		},
		'service-kyc': {
			primary: 'https://api.prod.cuv-prod.com/1/service-kyc',
		},
		'service-lexisnexis': {
			primary: 'https://api.prod.cuv-prod.com/1/service-lexisnexis',
		},
		'service-license': {
			primary: 'https://api.prod.cuv-prod.com/1/service-license',
		},
		'service-ltm': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ltm',
		},
		'service-ltm-renewal-reminder': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ltm-renewal-reminder',
		},
		'service-ltm-verification': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ltm-verification',
		},
		'service-marketing-consent': {
			primary: 'https://api.prod.cuv-prod.com/1/service-marketing-consent',
		},
		'service-mot': {
			primary: 'https://api.prod.cuv-prod.com/1/service-mot',
		},
		'service-motor-cover-check': {
			primary: 'https://api.prod.cuv-prod.com/1/service-motor-cover-check',
		},
		'service-motor-coverage': {
			primary: 'https://api.prod.cuv-prod.com/1/service-motor-coverage',
		},
		'service-mulsanne-reporting': {
			primary: 'https://api.prod.cuv-prod.com/1/service-mulsanne-reporting',
		},
		'service-news': {
			primary: 'https://api.prod.cuv-prod.com/1/service-news',
		},
		'service-notes': {
			primary: 'https://api.prod.cuv-prod.com/1/service-notes',
		},
		'service-notification': {
			primary: 'https://api.prod.cuv-prod.com/1/service-notification',
		},
		'service-ops-event': {
			primary: 'https://api.prod.cuv-prod.com/1/service-ops-event',
		},
		'service-payment': {
			primary: 'https://api.prod.cuv-prod.com/1/service-payment',
		},
		'service-payment-dispute': {
			primary: 'https://api.prod.cuv-prod.com/1/service-payment-dispute',
		},
		'service-policy': {
			primary: 'https://api.prod.cuv-prod.com/1/service-policy',
		},
		'service-policy-documents': {
			primary: 'https://api.prod.cuv-prod.com/1/service-policy-documents',
		},
		'service-policy-lookup': {
			primary: 'https://api.prod.cuv-prod.com/1/service-policy-lookup',
		},
		'service-profile': {
			primary: 'https://api.prod.cuv-prod.com/1/service-profile',
		},
		'service-promo': {
			primary: 'https://api.prod.cuv-prod.com/1/service-promo',
		},
		'service-quote': {
			primary: 'https://api.prod.cuv-prod.com/1/service-quote',
		},
		'service-quote-lookup': {
			primary: 'https://api.prod.cuv-prod.com/1/service-quote-lookup',
		},
		'service-react-asset': {
			primary: 'https://api.prod.cuv-prod.com/1/service-react-asset',
		},
		'service-sanctions-import': {
			primary: 'https://api.prod.cuv-prod.com/1/service-sanctions-import',
		},
		'service-sentiance': {
			primary: 'https://api.prod.cuv-prod.com/1/service-sentiance',
		},
		'service-sms': {
			primary: 'https://api.prod.cuv-prod.com/1/service-sms',
		},
		'service-social-driving': {
			primary: 'https://api.prod.cuv-prod.com/1/service-social-driving',
		},
		'service-staff': {
			primary: 'https://api.prod.cuv-prod.com/1/service-staff',
		},
		'service-survey': {
			primary: 'https://api.prod.cuv-prod.com/1/service-survey',
		},
		'service-tag': {
			primary: 'https://api.prod.cuv-prod.com/1/service-tag',
		},
		'service-task-queue': {
			primary: 'https://api.prod.cuv-prod.com/1/service-task-queue',
		},
		'service-taxi-checker': {
			primary: 'https://api.prod.cuv-prod.com/1/service-taxi-checker',
		},
		'service-telematics': {
			primary: 'https://api.prod.cuv-prod.com/1/service-telematics',
		},
		'service-terms': {
			primary: 'https://api.prod.cuv-prod.com/1/service-terms',
		},
		'service-upload': {
			primary: 'https://api.prod.cuv-prod.com/1/service-upload',
		},
		'service-upload-proxy': {
			primary: 'https://api.prod.cuv-prod.com/1/service-upload-proxy',
		},
		'service-upload-signer': {
			primary: 'https://api.prod.cuv-prod.com/1/service-upload-signer',
		},
		'service-user-config': {
			primary: 'https://api.prod.cuv-prod.com/1/service-user-config',
		},
		'service-vehicle': {
			primary: 'https://api.prod.cuv-prod.com/1/service-vehicle',
		},
		'service-vehicle-photo': {
			primary: 'https://api.prod.cuv-prod.com/1/service-vehicle-photo',
		},
		'service-vehicle-profile': {
			primary: 'https://api.prod.cuv-prod.com/1/service-vehicle-profile',
		},
		'service-vehicle-recognition': {
			primary: 'https://api.prod.cuv-prod.com/1/service-vehicle-recognition',
		},
		'service-vehicle-reminder': {
			primary: 'https://api.prod.cuv-prod.com/1/service-vehicle-reminder',
		},
		'service-wakam-pricing': {
			primary: 'https://api.prod.cuv-prod.com/1/service-wakam-pricing',
		},
		'service-watchlist': {
			primary: 'https://api.prod.cuv-prod.com/1/service-watchlist',
		},
	},
};
